import type { StackProps } from '@mui/material/Stack';
import type { ContainerProps } from '@mui/material/Container';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Container from '@mui/material/Container';

import { varAlpha } from '../utils/pallette';
import React from 'react';
import { Storefront } from '../models/StorefrontResponse';

// ----------------------------------------------------------------------

type ComponentBlockProps = StackProps & {
  title?: string;
  storefront: Storefront
};

export function ComponentBlock({ title, sx, storefront, children, ...other }: ComponentBlockProps) {
  return (
    <Stack
      sx={{
        px: 2,
        pt: 3,
        pb: 2,
        gap: 2,
        width: 1,
        flexWrap: 'wrap',
        borderRadius: 1.5,
        position: 'relative',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: varAlpha(storefront.activeColors.mainPage.pageSearchBoxBackground, 0.15),
        boxShadow: `0 0 0 1px ${varAlpha("0 0 0", 0.26)}`,
        ...sx,
      }}
      {...other}
    >
      {title && (
        <Box
          component="span"
          sx={{
            px: 1,
            top: 0,
            ml: 2.5,
            left: 0,
            py: 0.25,
            borderRadius: 2,
            position: 'absolute',
            color: storefront.activeColors.mainPage.pageText,
            bgcolor: varAlpha(storefront.activeColors.mainPage.pageSearchBoxBackground, 0.58),
            transform: 'translateY(-50%)',
            fontSize: (theme) => theme.typography.caption.fontSize,
            fontWeight: (theme) => theme.typography.fontWeightBold,
            border: `solid 1px ${varAlpha(storefront.activeColors.mainPage.avatarBackground, 0.74)}`,
          }}
        >
          {title}
        </Box>
      )}

      {children}
    </Stack>
  );
}

// ----------------------------------------------------------------------

export function ComponentContainer({ children, sx, ...other }: ContainerProps) {
  return (
    <Container
      sx={{
        mt: 10,
        mb: 15,
        gap: 5,
        display: 'flex',
        flexDirection: 'column',
        ...sx,
      }}
      {...other}
    >
      {children}
    </Container>
  );
}
